export function initializeTableEnhancements() {
    document.querySelectorAll('.wp-block-table table').forEach(function (table) {
        const headCells = table.querySelectorAll('thead th, thead td');
        if (!headCells.length) return;

        table.querySelectorAll('tbody tr').forEach(function (row) {
            const cells = Array.from(row.children).filter((cell) => !cell.hasAttribute('colspan'));

            cells.forEach(function (cell, index) {
                if (index === 0) return;

                if (headCells[index]) {
                    cell.setAttribute('data-label', headCells[index].textContent.trim());
                }
            });
        });
    });
}
